import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import type { IPanelTheme } from "app/pages/sales-intelligence/common-components/collapsible-panel";
import { DEFAULT_COLLAPSIBLE_PANEL_THEME } from "app/pages/sales-intelligence/common-components/collapsible-panel";
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";

export const StyledCategorySection = styled(Stack)`
    gap: 12px;
    padding: 16px;
`;

export const StyledViewMoreButton = styled(IconButton)`
    ${withSWReactIconFillColor(colorsPalettes.carbon[300])};
`;

export const StyledFiltersList = styled(Stack).attrs<{
    theme?: IPanelTheme;
    $hasOverlayScrollbar?: boolean;
}>((props) => ({
    ...props,
    theme: props.theme ?? DEFAULT_COLLAPSIBLE_PANEL_THEME,
}))<{ $hasOverlayScrollbar?: boolean }>`
    flex: 1;
    min-height: 0;

    margin: ${({ theme: { gapY } }) => `${gapY} 0`};

    padding: ${({ theme: { gapX } }) => `0 ${gapX}`};

    overflow-x: hidden;
    overflow-y: auto;

    /* Content gap based on scrollbar type */
    ${({ $hasOverlayScrollbar }) =>
        !$hasOverlayScrollbar &&
        css`
            @supports (scrollbar-gutter: stable) {
                scrollbar-gutter: stable;
                padding-right: 1.7px;
            }
        `}
`;

export const StyledFiltersListWrapper = styled(Stack)`
    flex: 1;
    min-height: 0;
`;
